import { Platform } from "react-native";

// The trio that hides a purely-visual node from assistive tech. iOS reads
// `accessibilityElementsHidden`, Android `importantForAccessibility`, and
// react-native-web translates NEITHER: the DOM wants `aria-hidden`, so that
// third prop is web-only. Same lesson as `accessibilityState` on LG-63, first
// applied at Auth/CodeField.tsx (the six decorative boxes under one real
// field). PG-34: pulled out once a second caller (the chart-cursor hint,
// visual-only "hold on a chart") needed the same three props.
export function hiddenFromScreenReader() {
  return {
    accessibilityElementsHidden: true,
    importantForAccessibility: "no-hide-descendants" as const,
    ...(Platform.OS === "web" ? { "aria-hidden": true as const } : {}),
  };
}
